import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import { signup } from "../../lib/shopperAuthApi";
import { useSession } from "../../hooks/useSession";

export default function ShopperSignup() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/browse";


  const [showAvatarPrompt, setShowAvatarPrompt] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const email = form.email.trim();
    const password = form.password.trim();

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
await signup({ email, password });

navigate("/verify-email-sent", {
  replace: true,
  state: { email, from },
});
    } catch (err) {
      console.error("Shopper signup failed", err);
      setError(err?.message || "Could not create account.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <MerchantPageShell
      eyebrow="Shopper Account"
      title="Create account"
      lede="Save your avatar, wardrobe, and edits across sessions."
    >
      <form className="merchant-form" onSubmit={handleSubmit}>
        <label className="merchant-field">
          <span className="merchant-label">Email</span>
          <input
            className="merchant-input"
            type="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
            placeholder="hello@youremail.com"
            autoComplete="email"
          />
        </label>

        <label className="merchant-field">
          <span className="merchant-label">Password</span>
          <input
            className="merchant-input"
            type="password"
            value={form.password}
            onChange={(e) => updateField("password", e.target.value)}
            placeholder="Create a password"
            autoComplete="new-password"
          />
        </label>

        {error ? <p className="merchant-error">{error}</p> : null}

        <div className="merchant-actions">
          <button className="gold-btn" type="submit" disabled={submitting}>
            {submitting ? "Creating account..." : "Create account"}
          </button>

          <p
            style={{
              margin: 0,
              fontSize: 15,
              color: "rgba(43, 43, 43, 0.78)",
              display: "flex",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <span>Already have an account?</span>
            <Link
              to="/login"
              style={{
                color: "#5b1f2b",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Sign in
            </Link>
          </p>
        </div>
      </form>
{showAvatarPrompt ? (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.25)",
      backdropFilter: "blur(2px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      animation: "fadeIn 0.2s ease",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: 420,
        padding: "24px 22px",
        borderRadius: 20,
        background: "rgba(255,255,255,0.95)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontSize: 18,
          fontWeight: 600,
          color: "rgba(20,20,20,0.92)",
        }}
      >
        Personalise your mannequin?
      </div>

      <div
        style={{
          fontSize: 14,
          color: "rgba(40,40,40,0.7)",
          lineHeight: 1.5,
        }}
      >
        Adjust your mannequin’s shape and proportions so try-on reflects you more accurately.
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          marginTop: 6,
        }}
      >
        <button
          className="gold-btn"
          type="button"
          onClick={() => navigate("/account/avatar")}
        >
          Yes, personalise
        </button>

        <button
          type="button"
          onClick={() => navigate(from, { replace: true })}
          style={{
            background: "none",
            border: "none",
            fontSize: 14,
            color: "rgba(40,40,40,0.7)",
            cursor: "pointer",
          }}
        >
          Skip for now
        </button>
      </div>
    </div>
  </div>
) : null}
    </MerchantPageShell>
  );
}